import PageContainer from '../components/PageContainer';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <PageContainer>
      <Contact />
    </PageContainer>
  );
};

export default ContactPage; 